import '../../common/utils/polyfills';
import toHeadersFromHttpHeaders from './toHeadersFromHttpHeaders';
import { HttpResponse } from '../interfaces';
import { isArrayBuffer } from '../../common/utils/stringify';

type BasicResponseBody = ArrayBuffer | Blob | string | undefined;

const toResponseFromHttpResponse = async (
  res: HttpResponse,
  url: RequestInfo
): Promise<Response> => {
  return new ResponseWrapper(res, url);
};

const isBasicResponseBody = (obj?: unknown): obj is BasicResponseBody => {
  return (
    isArrayBuffer(obj) ||
    obj instanceof Blob ||
    typeof obj === 'string' ||
    typeof obj === 'undefined'
  );
};

const makeResponseBody = (res: HttpResponse): BasicResponseBody => {
  if (isBasicResponseBody(res.body)) {
    return res.body;
  } else if (typeof res.body === 'object') {
    return JSON.stringify(res.body);
  }
  return undefined;
};

class ResponseWrapper extends Response {
  headers: Headers;
  original: HttpResponse;
  status: number;
  statusText: string;
  url: string;
  constructor(res: HttpResponse, url: RequestInfo) {
    super(makeResponseBody(res));
    this.headers = toHeadersFromHttpHeaders(res.headers);
    this.original = res;
    this.status = res.status;
    this.statusText = res.statusText as string;
    this.url = url.toString();
  }

  get trailer(): Promise<Headers> {
    return Promise.resolve(this.headers);
  }

  clone(): Response {
    return new ResponseWrapper(this.original, this.url);
  }
}

export default toResponseFromHttpResponse;
